import { render, staticRenderFns } from "./RiskPointinfo.vue?vue&type=template&id=40dc6b34&scoped=true"
import script from "./RiskPointinfo.vue?vue&type=script&lang=js"
export * from "./RiskPointinfo.vue?vue&type=script&lang=js"
import style0 from "./RiskPointinfo.vue?vue&type=style&index=0&id=40dc6b34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dc6b34",
  null
  
)

export default component.exports